import {Icon, Typography} from "@bonprix/design-system";

export default function StatsItem ({text, iconVariant }) {
    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', marginTop:'8px' }}>
                <Icon variant={iconVariant} />
                <span style={{ marginLeft: '8px' }}>
                    <Typography variant="body1" component="span">
                        {text}
                    </Typography>
                </span>
            </div>
        </>
    );
}